import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M14.0938 11.6874C13.5975 11.1874 12.3956 10.4577 11.8125 10.1636C11.0531 9.78113 10.9906 9.74988 10.3938 10.1933C9.99563 10.4893 9.73094 10.7536 9.265 10.6543C8.79906 10.5549 7.78656 9.99457 6.9 9.11082C6.01344 8.22707 5.42062 7.18519 5.32094 6.72082C5.22125 6.25644 5.49 5.99488 5.78312 5.59582C6.19625 5.03332 6.165 4.93957 5.81187 4.18019C5.53656 3.58957 4.78562 2.39894 4.28375 1.90519C3.74687 1.37488 3.74687 1.46863 3.40094 1.61238C3.11929 1.73085 2.8491 1.87489 2.59375 2.04269C2.09375 2.37488 1.81625 2.65082 1.62219 3.0655C1.42812 3.48019 1.34094 4.45238 2.34312 6.273C3.34531 8.09363 4.04844 9.02457 5.50375 10.4758C6.95906 11.9271 8.07813 12.7074 9.71406 13.6249C11.7378 14.7583 12.5141 14.5374 12.93 14.3436C13.3459 14.1499 13.6231 13.8749 13.9559 13.3749C14.1242 13.12 14.2685 12.8501 14.3872 12.5686C14.5313 12.2239 14.625 12.2239 14.0938 11.6874Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	})
});
export default SvgPeople;
